import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "all-pointer-events",
  style: {"font-size":"20px"}
}

import { computed, onMounted, ref, watch } from 'vue';

import FieldHistoryBtn from 'SharedComponents/Fields/FieldHistoryBtn.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
  useBaseFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import {
  SelectFieldValue,
  useCatalogsLoader,
} from 'SharedComponents/Fields/composables/useCatalogsLoader';
import useFieldParams from 'SharedComponents/Fields/composables/useFieldParams';
import { useTooltip } from 'SharedComponents/Fields/composables/useFieldTooltip';
import SOptionGroup from 'SharedComponents/ui/Checkbox/SOptionGroup.vue';
import SSelect from 'SharedComponents/ui/Select/SSelect.vue';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import useValidation, { ValidationRule } from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { SelectFieldParams } from 'SharedDir/declarations/fields';

type SelectFieldProps = ValuedFieldProps &
  PropValue<SelectFieldValue> & { params: SelectFieldParams };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SelectField' },
  __name: 'SelectField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {}
  }, defaultValuedProps),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emit = __emit;
const { MaxLength } = useValidation();

const { innerValue, emitValue } = useValue(props, emit, {
  transform: (v) => {
    if (props.params.multiple) {
      return Array.isArray(v.value) ? v : { value: [] };
    }
    return Array.isArray(v.value) ? { value: '' } : v;
  },
});

const customRules = computed(() => {
  const rules: Array<ValidationRule> = [];
  if (props.params.multiple && props.params.maxElements) {
    rules.push(MaxLength(props.params.maxElements));
  }
  return rules;
});

const { params, validationRules } = useFieldParams<SelectFieldParams>(props, { customRules });

const { validationErrorStatus, hasHistory, revealHistory } = useBaseFieldProps(props, emit);

const tooltip = useTooltip(props);

const { loading, options, filter, loadCatalog, setFilterProperty } = useCatalogsLoader(
  innerValue,
  params
);

onMounted(async () => {
  await loadCatalog(params.value.catalogSlug);
});

return (_ctx: any,_cache: any) => {
  const _component_q_field = _resolveComponent("q-field")!

  return (_unref(params).useDropdown)
    ? (_openBlock(), _createBlock(SSelect, {
        key: 0,
        ref: "select",
        modelValue: _unref(innerValue).value,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).value) = $event)),
          _unref(emitValue)
        ],
        multiple: _unref(params).multiple,
        "use-chips": _unref(params).multiple,
        options: _unref(options),
        readonly: _ctx.readonly,
        label: _ctx.label,
        "option-value": "value",
        "option-label": "label",
        class: _normalizeClass({ required: _ctx.required }),
        required: _ctx.required,
        "emit-value": "",
        "map-options": "",
        clearable: "",
        outlined: "",
        dense: "",
        "options-dense": "",
        error: _unref(validationErrorStatus),
        "error-message": _ctx.errorMessage,
        "use-input": _unref(params).useSearch,
        loading: _unref(loading),
        rules: _unref(validationRules),
        onFilter: _unref(setFilterProperty)
      }, _createSlots({ _: 2 }, [
        (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
          ? {
              name: "prepend",
              fn: _withCtx(() => [
                (_unref(tooltip))
                  ? (_openBlock(), _createBlock(Tooltip, {
                      key: 0,
                      text: _unref(tooltip)
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true),
                (_ctx.showHistory && _unref(hasHistory))
                  ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                      key: 1,
                      history: _ctx.history,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(revealHistory)(_ctx.label)), ["stop"]))
                    }, null, 8, ["history"]))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "multiple", "use-chips", "options", "readonly", "label", "class", "required", "error", "error-message", "use-input", "loading", "rules", "onUpdate:modelValue", "onFilter"]))
    : (_openBlock(), _createBlock(_component_q_field, {
        key: 1,
        ref: "optionGroup",
        modelValue: _unref(innerValue).value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(innerValue).value) = $event)),
        borderless: "",
        "stack-label": "",
        "label-slot": "",
        error: _unref(validationErrorStatus),
        "error-message": _ctx.errorMessage,
        class: _normalizeClass(["s-input s-form-input_wrapper field-select__option-group column", { 's-input--required': _ctx.required }]),
        rules: _unref(validationRules)
      }, _createSlots({
        label: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            (_unref(tooltip))
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  text: _unref(tooltip)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
          ])
        ]),
        control: _withCtx(() => [
          _createVNode(SOptionGroup, {
            modelValue: _unref(innerValue).value,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_unref(innerValue).value) = $event)),
              _unref(emitValue)
            ],
            disable: _ctx.readonly,
            type: _unref(params).multiple ? 'checkbox' : 'radio',
            "error-status": _unref(validationErrorStatus),
            "error-message": _ctx.errorMessage,
            options: _unref(options)
          }, null, 8, ["modelValue", "disable", "type", "error-status", "error-message", "options", "onUpdate:modelValue"])
        ]),
        _: 2
      }, [
        (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
          ? {
              name: "prepend",
              fn: _withCtx(() => [
                (_ctx.showHistory && _unref(hasHistory))
                  ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                      key: 0,
                      history: _ctx.history,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(revealHistory)(_ctx.label)))
                    }, null, 8, ["history"]))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "error", "error-message", "class", "rules"]))
}
}

})